import { h, ComponentChild, Fragment, toChildArray } from "preact";

import { MenuButtonAsMenuItem } from "../MenuButton";
import Submenu from "../Submenu";
import withMenuItem, { WithMenuItemProps } from "../withMenuItem";

import "../style.css";

interface Props extends WithMenuItemProps {
    checkedOptionValues: string[];
    options: {
        value: string;
        content: string;
        disabled?: boolean;
    }[];
    minNumberOfCheckedOptions?: number;
    footer?: JSX.Element;
    onChange?: (checkedOptionValues: string[]) => void;
}

function MultiSelectSubmenu({
    content,
    options,
    indicesPath,
    open,
    highlighted,
    checkedOptionValues,
    minNumberOfCheckedOptions = 0,
    footer,
    disabled,
    onChange,
    handleMenuChildClick,
    onMenuItemMouseEnter,
    onMenuItemMouseMove,
    handleMenuChildMouseMove,
    handleMenuChildMouseEnter
}: Props) {
    function handleItemClick(event: Event, value?: string, checked?: boolean) {
        let newCheckedOptionNames = checkedOptionValues ? [...checkedOptionValues] : [];

        if (checked) {
            newCheckedOptionNames.push(value!);
        } else {
            newCheckedOptionNames = newCheckedOptionNames.filter(current => current !== value);
        }

        onChange?.(newCheckedOptionNames);
        handleMenuChildClick?.(event, value);
    }

    const checkedStatuses = options.map(option => checkedOptionValues.includes(option.value));
    const checkedOptionCount = checkedStatuses.filter(value => value).length;
    const disableCheckedOptions = minNumberOfCheckedOptions >= checkedOptionCount;
    const footerItems: ComponentChild[] =
            footer?.type === Fragment ? toChildArray(footer.props.children) : [footer];

    return (
        <Submenu
            content={content}
            indicesPath={indicesPath}
            highlighted={highlighted}
            open={open}
            disabled={disabled}
            handleMenuChildMouseEnter={handleMenuChildMouseEnter}
            handleMenuChildMouseMove={handleMenuChildMouseMove}
            onMenuItemMouseEnter={onMenuItemMouseEnter}
            onMenuItemMouseMove={onMenuItemMouseMove}>
            {options.map((option, index) => (
                <MenuButtonAsMenuItem
                    key={`${option.content}-${option.value}`}
                    value={option.value}
                    content={option.content}
                    checked={checkedStatuses[index]}
                    disabled={option.disabled}
                    inactionable={disableCheckedOptions && checkedStatuses[index]}
                    onClick={handleItemClick}/>
            ))}
            {...footerItems}
        </Submenu>
    );
}

const MultiSelectSubmenuAsMenuItem = withMenuItem(MultiSelectSubmenu);

export default MultiSelectSubmenu;
export { MultiSelectSubmenuAsMenuItem };
